module.exports = __webpack_public_path__ + "static/media/quadriceps.c1c7fdcc.png";